export default {
  rootGrid: {
    flexGrow: 1,
  },
  title: {
    textAlign: 'center',
  },
  loginButton: {
    marginTop: 20,
    paddingHorizontal: 65,
    paddingVertical: 7,
  },
}
